export default {
    connectedYoutubeAccounts(state) {
        return state.connectedYoutubeAccounts;
    },
    authUrl(state) {
        return state.authUrl;
    }
}